const TELEMETRY_BODY_LIMIT = 5000;

type NewRelicPageActionAttribute = string | number;
type NewRelicCustomEventAttributes = Record<string, string | number | boolean>;

declare const newrelic: {
  addPageAction: (name: string, attributes?: Record<string, NewRelicPageActionAttribute>) => void;
  recordCustomEvent?: (eventType: string, attributes?: NewRelicCustomEventAttributes) => void;
};

const normalizePageActionAttributes = (
  attributes: NewRelicCustomEventAttributes,
): Record<string, NewRelicPageActionAttribute> => {
  return Object.entries(attributes).reduce<Record<string, NewRelicPageActionAttribute>>((acc, [key, value]) => {
    acc[key] = typeof value === 'boolean' ? String(value) : value;
    return acc;
  }, {});
};

export const truncateForTelemetry = (value: unknown): string => {
  if (typeof value === 'string') return value.slice(0, TELEMETRY_BODY_LIMIT);
  if (value === undefined || value === null) return '';

  try {
    return JSON.stringify(value).slice(0, TELEMETRY_BODY_LIMIT);
  } catch {
    return String(value).slice(0, TELEMETRY_BODY_LIMIT);
  }
};

export const recordNewRelicCustomEvent = (eventType: string, attributes: NewRelicCustomEventAttributes) => {
  if (newrelic.recordCustomEvent) {
    newrelic.recordCustomEvent(eventType, attributes);
  }

  newrelic.addPageAction(eventType, normalizePageActionAttributes(attributes));
};
